module.exports = __webpack_public_path__ + "media/images/LED-4-7951344f81dd3fa91257376c841e974b.png";